"use client";

import { useMarketHint } from "@/components/market/market-hint-context";
import type { Market } from "@/lib/market/market";

/**
 * Client-side market gate for statically-cached / ISR pages (e.g. job detail,
 * `revalidate = 3600`) that cannot read geo server-side without forcing dynamic
 * rendering.
 *
 * The no-geo default market is `indonesia` (matches `resolveMarket`: unknown ⇒
 * indonesia). So the initial render — SSR/ISR HTML and the client's first paint —
 * shows ONLY an `indonesia` gate's children (crawlers + ID users see them; SEO
 * preserved) and hides a `global` gate's children. After mount, the resolved
 * market from `<MarketHintProvider>` reconciles: an `indonesia` block hides for
 * global visitors, a `global` block appears for them. The provider defaults to
 * `indonesia` until resolution completes, so server and client agree — no
 * hydration mismatch.
 */
export function MarketGate({
	market,
	children,
}: {
	market: Market;
	children: React.ReactNode;
}) {
	const resolved = useMarketHint();
	if (resolved !== market) return null;
	return <>{children}</>;
}
